export default __webpack_public_path__ + "static/media/copyright.85dab81e.svg";